import { isIOS } from 'utils/device-detect';
import { isLiveJasmin, isOranum } from './sites';
import { Products } from './globalConfig';

type MobileAppLinks = {
    [domain in Products]: string;
};

const mobileAppLinksIos: MobileAppLinks = {
    livejasmin: 'https://vibesmessenger.com/',
    oranum: 'https://apps.apple.com/us/app/oranum-broadcaster/id1564106004',
};

const mobileAppLinksAndroid: MobileAppLinks = {
    livejasmin: 'https://vibesmessenger.com/',
    oranum: 'https://broadcaster.oranum.com/redirect-to-app-store', // url with ? queryparams was not working in [url] bbcode.
};

export const getIosAppUrl = (): string => {
    if (isLiveJasmin) {
        return mobileAppLinksIos.livejasmin;
    }
    if (isOranum) {
        return mobileAppLinksIos.oranum;
    }
    throw new Error('Illegal environment');
};

export const getAndroidAppUrl = (): string => {
    if (isLiveJasmin) {
        return mobileAppLinksAndroid.livejasmin;
    }
    if (isOranum) {
        return mobileAppLinksAndroid.oranum;
    }
    throw new Error('Illegal environment');
};

export const getMobileAppUrl = (): string => {
    if (isIOS()) {
        return getIosAppUrl();
    }
    return getAndroidAppUrl();
};

interface MobileApp {
    appName: string;
    downloadUrl: string;
}

export const getMobileApp = (theme: Products): MobileApp => {
    switch (theme) {
        case 'oranum':
            return {
                appName: 'Oranum Broadcaster App',
                downloadUrl: getMobileAppUrl(),
            };
        default:
            return {
                appName: 'Vibes App',
                downloadUrl: getMobileAppUrl(),
            };
    }
};
